export function truncate(str, len) {
    return str.length > len ? str.slice(0, len) + "…" : str;
}
export function toDOSLineEndings(val) {
    return val.replace(/\n/g, "\r\n");
}
export function capitalize(str) {
    return str
        .split(" ")
        .map((s) => `${s[0]?.toUpperCase() || ""}${s.slice(1)}`)
        .join(" ");
}
export function pathToPascalCase(path) {
    return path
        .split("/")
        .filter(Boolean) // remove empty strings from consecutive '/'
        .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join("");
}
export function escapeXML(str) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}
/**
 * Sanitizes a filename by removing or replacing problematic characters that may cause
 * issues with storage providers or file systems.
 *
 * Removes/replaces:
 * - Hash symbols (#) which can be interpreted as URL fragments
 * - Duplicate file extensions (e.g., "file.pdf.pdf" becomes "file.pdf")
 * - Leading/trailing whitespace
 * - Multiple consecutive spaces
 *
 * @param filename The filename to sanitize (without extension)
 * @param extension The file extension (without leading dot)
 * @returns The sanitized filename
 */
export function sanitizeFilename(filename, extension) {
    // Remove leading/trailing whitespace
    let sanitized = filename.trim();
    // Replace hash symbols with underscores
    sanitized = sanitized.replace(/#/g, "_");
    // Replace multiple consecutive spaces with a single space
    sanitized = sanitized.replace(/\s+/g, " ");
    // Remove all occurrences of the extension (with optional surrounding whitespace)
    // This prevents "file.pdf.pdf" and "file .pdf.pdf" issues
    const extensionPattern = new RegExp(`\\s*\\.${extension.replace(/\./g, "\\.")}\\s*`, "gi");
    sanitized = sanitized.replace(extensionPattern, "");
    // Trim again after removing extension
    sanitized = sanitized.trim();
    // Remove characters that would result in just underscores or spaces
    // If the result is only non-alphanumeric characters, use default
    if (!sanitized || /^[_\s]+$/.test(sanitized)) {
        sanitized = "document";
    }
    return sanitized;
}
//# sourceMappingURL=string.util.js.map